// eslint-disable-next-line import/prefer-default-export
export var shape = {
  borderRadius: '4px'
};